import React from 'react';
import styles from './styles.scss';

function ProductExamples({
  type,
  examples
}) {
  return (
    <div className="container-fluid main-container">
      <div className="row">
        <div className="col-md-10 col-md-offset-1 col-sm-12">
          <div className="row">
            <div className="col-sm-12 text-center mt60 mb100">
              <div className={styles.container}>
                <span className="bold">
                  EXAMPLES OF {type.toUpperCase()}S:&nbsp;
                </span>
                <span className="light">
                  {examples}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductExamples;



// WEBPACK FOOTER //
// ./src/components/ProductExamples/index.js